import { render, staticRenderFns } from "./AgentBetHistory.vue?vue&type=template&id=67b2489b&lang=html"
import script from "./AgentBetHistory.vue?vue&type=script&lang=js"
export * from "./AgentBetHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports